const COLORS = {
  Мод: "bg-amber-500/20 text-amber-300 border-amber-500/30",
  PRO: "bg-violet-500/20 text-violet-300 border-violet-500/30",
};
const DEFAULT = "bg-cyan-500/20 text-cyan-300 border-cyan-500/30";

export default function Badge({ text, className = "" }) {
  if (!text) return null;
  const c = COLORS[text] || DEFAULT;
  return (
    <span
      data-testid="app-badge"
      className={`inline-block shrink-0 text-[10px] font-bold px-2 py-0.5 rounded-full border ${c} ${className}`}
    >
      {text}
    </span>
  );
}
